import MobileDatePickerContainer from './MobileDatePickerContainer';

export default MobileDatePickerContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/MobileDatePicker/index.js